import template from './appFooter.html';
import controller from './appFooter.controller';

let appFooterComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default appFooterComponent;



// WEBPACK FOOTER //
// ./app/common/appFooter/appFooter.component.js